import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  CircularProgress,
  Container,
  Grid,
  Paper,
  Stack,
  Typography
} from '@mui/material';
import { RootState } from '../app/store';
import {
  useGetUserInfoQuery,
  useSearchSessionsQuery
} from '../services/api';
import SessionCard from './SessionCard';
import SessionDialog from './SessionDialog';
import { StyledHeaderBox } from '../StyledHeaderBox';
import { useNavigate, useParams } from 'react-router-dom';

const SessionsList = () => {
  const search = useSelector((x: RootState) => x.search)
  const { data: sessions, isLoading, isFetching } = useSearchSessionsQuery(search)
  const { data: user } = useGetUserInfoQuery()
  const { guid } = useParams<{ guid?: string }>();
  const [selectedSession, setSelectedSession] = useState<string | undefined>(guid)
  const navigate = useNavigate();
  const onSelectSession = (selected?: string) => {
    setSelectedSession(selected)
    navigate(selected ? `/dashboard/${selected}` : '/dashboard')
  }
  return (
    <>
      <StyledHeaderBox>
        <Typography
          sx={{
            marginLeft: { xs: 1 }
          }}
          variant="h6"
        >{search.previous
          ? 'Previous'
          : 'Upcoming'
          }{search.booked
            ? ' Booked'
            : search.watching
              ? ' Watched'
              : ''
          } Sessions{search.tag
            ? ` on "${search.tag}"`
            : ''}</Typography>
      </StyledHeaderBox>
      <Container>
        <Paper
          style={{
            padding: 10,
          }}
        >
          <Grid
            container
            spacing={1}
          >
            {isLoading || isFetching
              ? <Stack
                alignItems="center"
                spacing={5}
                width='100%'
              >
                <CircularProgress />
              </Stack>
              : !sessions?.length
                ? <Typography
                  fontSize={20}
                  fontWeight={700}
                  textAlign='center'
                  width='100%'
                >No Sessions Found.</Typography>
                : null}
            {sessions?.map((session, index) => (
              <SessionCard
                key={session.guid}
                index={index}
                onClick={() => onSelectSession(session.guid)}
                session={session}
              />
            ))}
          </Grid>
        </Paper>
      </Container>
      <SessionDialog
        onClose={() => onSelectSession(undefined)}
        guid={selectedSession}
        showRelated={user?.role !== 'practitioner'}
      />
    </>
  )
}

export default SessionsList;


